import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import Contact from './pages/Contact';
import Partners from './pages/Partners';
import News from './pages/News';
import AlertMap from './pages/AlertMap';
import ReportViolation from './pages/ReportViolation';
import JoinXRU from './pages/JoinXRU';
import LegalHelp from './pages/LegalHelp';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import LanguageSplash from './components/LanguageSplash';

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered:', registration.scope);
      })
      .catch(error => {
        console.log('SW registration failed:', error);
      });
  });
}

// Component to handle URL params for PWA shortcuts
function AlertMapWithAction() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const action = params.get('action');
  
  return <AlertMap autoOpenReport={action === 'report'} />;
}

// Main app content with language splash check
function AppContent() {
  const { hasSelectedLanguage, selectLanguage } = useLanguage();
  
  if (!hasSelectedLanguage) {
    return <LanguageSplash onSelectLanguage={selectLanguage} />;
  }
  
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/news" element={<News />} />
            <Route path="/alert-map" element={<AlertMapWithAction />} />
            <Route path="/report-violation" element={<ReportViolation />} />
            <Route path="/join" element={<JoinXRU />} />
            <Route path="/legal-help" element={<LegalHelp />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <PWAInstallPrompt />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
